/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProofVersionIndex model module.
 * @module model/ProofVersionIndex
 * @version V1
 */
class ProofVersionIndex {
    /**
     * Constructs a new <code>ProofVersionIndex</code>.
     * @alias module:model/ProofVersionIndex
     */
    constructor() { 
        
        ProofVersionIndex.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProofVersionIndex</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProofVersionIndex} obj Optional instance to populate.
     * @return {module:model/ProofVersionIndex} The populated <code>ProofVersionIndex</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProofVersionIndex();

            if (data.hasOwnProperty('isCurrentVersion')) {
                obj['isCurrentVersion'] = ApiClient.convertToType(data['isCurrentVersion'], 'Boolean');
            }
            if (data.hasOwnProperty('isHiddenFromApproversAndReviewers')) {
                obj['isHiddenFromApproversAndReviewers'] = ApiClient.convertToType(data['isHiddenFromApproversAndReviewers'], 'Boolean');
            }
            if (data.hasOwnProperty('proofVersionId')) {
                obj['proofVersionId'] = ApiClient.convertToType(data['proofVersionId'], 'Number');
            }
            if (data.hasOwnProperty('versionNumber')) {
                obj['versionNumber'] = ApiClient.convertToType(data['versionNumber'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProofVersionIndex</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProofVersionIndex</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} isCurrentVersion
 */
ProofVersionIndex.prototype['isCurrentVersion'] = undefined;

/**
 * @member {Boolean} isHiddenFromApproversAndReviewers
 */
ProofVersionIndex.prototype['isHiddenFromApproversAndReviewers'] = undefined;

/**
 * @member {Number} proofVersionId
 */
ProofVersionIndex.prototype['proofVersionId'] = undefined;

/**
 * @member {Number} versionNumber
 */
ProofVersionIndex.prototype['versionNumber'] = undefined;






export default ProofVersionIndex;

